import { cva } from 'class-variance-authority';

export const buttonVariants = cva(
  'inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50',
  {
    variants: {
      variant: {
        default: 'bg-primary text-primary-foreground hover:bg-primary/90',
        destructive:
          'bg-destructive text-destructive-foreground border border-destructive-foreground rounded-lg hover:bg-destructive/90',
        outline:
          'border bg-[hsl(var(--input-background))] hover:bg-accent hover:text-accent-foreground',
        secondary: 'bg-accent text-foreground rounded-lg hover:bg-accent/90 border border-border',
        ghost: 'hover:bg-midground text-foreground',
        link: 'text-foreground hover:text-foreground/70 underline-offset-4 hover:underline',
        dotted: 'border border-dashed border-border hover:bg-midground text-foreground'
      },
      size: {
        default: 'h-10 px-4 py-2',
        sm: 'h-9 rounded-lg px-3',
        lg: 'h-11 rounded-lg px-8',
        icon: 'h-10 w-10'
      }
    },
    defaultVariants: {
      variant: 'default',
      size: 'default'
    }
  }
);
